<script setup lang="ts">
import { computed } from 'vue'

interface Props {
	unreadCount: number
}

// No `click` emit: a declared emit would swallow the onClick a v-menu activator passes in, so the
// listener falls through to the button like any other attribute.
const props = withDefaults(defineProps<Props>(), {
	unreadCount: 0,
})

function displayCount(count: number): string {
	return count > 99 ? '99+' : String(count)
}

const label = computed(() =>
	props.unreadCount > 0 ? `Notifications, ${props.unreadCount} unread` : 'Notifications',
)
</script>

<template>
	<v-btn
		icon
		variant="text"
		:aria-label="label"
	>
		<v-badge
			v-if="unreadCount > 0"
			:key="unreadCount"
			:content="displayCount(unreadCount)"
			color="error"
			floating
			class="notification-bell__badge"
		>
			<i class="fa-solid fa-bell" />
		</v-badge>
		<i
			v-else
			class="fa-regular fa-bell"
		/>
	</v-btn>
</template>

<style scoped lang="scss">
// Badge pops in whenever the unread count changes (re-keyed above)
.notification-bell__badge :deep(.v-badge__badge) {
	animation: pop-in 250ms $ease-out-expo;
}
</style>
